<div class="flex">
  @for (item of config.items; track item) {
    <span
      role="button"
      tabindex="0"
      (click)="itemclicked(item)"
      (keydown.enter)="itemclicked(item)"
      (keydown.space)="$event.preventDefault(); itemclicked(item)"
      [ngClass]="{
        'bg-teal-50  text-teal-700 ring-teal-700/10': item.active,
        'bg-gray-50 text-gray-600 ring-gray-500/10': !item.active,
      }"
      class="inline-flex items-center rounded-lg px-2 py-1 text-xs font-medium ring-1 ring-inset mr-3 hover:bg-teal-100 hover:text-teal-800 hover:ring-teal-800/10 cursor-pointer"
      >{{ item.title }}</span
    >
  }
</div>
